import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import updateBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/UpdateBillTo";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { getCurrentShipTosDataView, getCurrentShipToState, getShipTosDataView, } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AddressInfoDisplay from "@insite/content-library/Components/AddressInfoDisplay";
// import CustomerAddressForm from "@insite/content-library/Components/CustomerAddressForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import EditIcon from "@MasterBluePrint/Icons/EditIcon";
import InfoNewIcon from "@MasterBluePrint/Icons/InfoNew";
import CustomerAddressForm from "@MasterBluePrint/Overrides/Components/CustomerAddressForm"
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentBillTo: getCurrentBillToState(state).value,
    countries: getCurrentCountries(state),
    billToAddressFields: getAddressFieldsDataView(state).value?.billToAddressFields,
    currentShipTosDataView: getCurrentShipTosDataView(state),
});

const mapDispatchToProps = {
    updateBillTo,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CurrentBillingAddressStyles {
    gridContainer?: GridContainerProps;
    headingGridItem?: GridItemProps;
    headingText?: TypographyProps;
    editLinkGridItem?: GridItemProps;
    editLink?: LinkPresentationProps;
    addressFormModal?: ModalPresentationProps;
    addressInfoDisplayGridItem?: GridItemProps;
    
    billingEditInfoMessage?: GridItemProps;
    billingEditInfoText?: InjectableCss;
    icontooltip?: InjectableCss;

    currentBillingHandlingLabel?: TypographyProps;
    currentBillingHandlingLabelNew?: TypographyProps;
    shippingAndHandlingValue?: TypographyProps;
    tooltip?: InjectableCss;
    tooltipHeading?: InjectableCss;
    tooltipContent?: InjectableCss;
    tooltipIcon?: InjectableCss;
    closeContainer?: InjectableCss;
    addressFormModalCustom?: InjectableCss;
    currentAddressAction?: InjectableCss;
}

export const currentBillingAddressStyles: CurrentBillingAddressStyles = {
    editLink: {
        css: css`
            padding-left: 1.25rem;
            margin-left: 0.9375rem;
            border-left: 1px solid ${themeColors.colorBorderBrands};
            

            svg {
                width: 1.25rem;
                height: 1.25rem;
            }
        `,
    },
    currentAddressAction: {
        css:css`
            display: flex;
            width: 100%;
            align-items: center;
            margin-top: auto;
            border-top: 1px solid ${themeColors.colorBorderBrands};
            padding-top: 0.625rem;
            justify-content: flex-end;
        `,
    },
    closeContainer: {
        css: css`
            position: absolute;
            left: 1.8rem;
            top: -5rem;
            z-index: 9;
            cursor: pointer;
            .close-label {
                color: ${themeColors.colorBrandsSeeMore};
                font-family: Roboto;
                font-size: 0.875rem;
                letter-spacing: 0;
                line-height: 1;
                display: inline-block;
                margin-right: 0.525rem;
                vertical-align: middle;
            }
            .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1rem;
                height: 1rem;
                svg {
                    height: 1rem;
                    width: 1rem;
                    color: ${themeColors.colorBrandsSeeMore};
                }
            }
            @media screen and (max-width: 990px) {
                right: 1.25rem;
            }
        `,
    },  
    billingEditInfoMessage: {
        width: 12,
        css:css`
            position: relative;
            border: 1px solid ${themeColors.colorNavajoWhite};
            border-radius: 0.125rem;
            background-color: ${themeColors.colorAntiqueWhite};
            padding: 0.8125rem 1.0625rem 1.0625rem;
            margin: 0.9375rem 0.625rem 0 -0.375rem!important;
        `,
    },
    billingEditInfoText: {
        css:css`
            width: 100%;
            position: relative;
            color: ${themeColors.colorSquidInk};
            font-family: Lato;
            font-size: 1rem;
            letter-spacing: 0;
            line-height: 1.1875rem;
            padding-right: 1.5625rem;
        `,
        
    },
    icontooltip: {
        css:css`
            display: inline-block;
            text-align: right;

            .iconTooltipText {
                visibility: hidden;

                &:hover {
                    visibility:visible;
                }
            }
        `,
    },
    gridContainer: { 
        gap: 2,
        css:css`
            border: 1px solid ${themeColors.colorPaleAqua};
            border-radius: 2px;
            margin: 0.625rem 0;
        
            > div {
                background-color: ${themeColors.colorAliceBlue};
                padding: 2.125rem 1.0625rem 1.0625rem 2.0625rem;
                min-height: 25.625rem;
                border: 1px solid ${themeColors.colorPaleAqua};
                flex-flow: column;
                border-radius: 0.125rem;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null, 
                        css`
                            margin: 0;
                        `,
                        null,
                    ],
                    "max",
                )
            };
        `, 
    },
    headingGridItem: { width: 12 },
    headingText: { 
        variant: "h5", 
        css:css`
            color: ${themeColors.colorPrimary};
            font-family: Roboto;
            font-size: 1.125rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.4375rem;

            .defaultText {
                color: ${themeColors.colorBrandsSeeMore};
                font-family: Lato;
                font-size: 0.9375rem;
                font-style: italic;
                font-weight: ${themeFontWeights.fontWeightForBold};
                letter-spacing: 0.17px;
                line-height: 1.125rem;
            }
        `,
    },
    editLinkGridItem: { 
        width: 2,
        css:css`
            justify-content: flex-end;
            &:empty {
                display: none;
            }
        `,
     },
    addressFormModal: { sizeVariant: "medium" },
    addressFormModalCustom: {
        css:css`
            div[class^='ModalContent'], 
            div[class*=' ModalContent']{
                position: relative;
                padding-bottom: 11.1875rem !important;
                height: calc(100vh - 13.1875rem);

                @media screen and (max-width: 767px) {
                    padding-bottom: 10.1875rem !important;  
                    height: calc(100vh - 13.1875rem);
                }

                @media screen and (max-width: 540px) { 
                    height: calc(100vh - 11.8rem);
                    padding-bottom: 11.8rem !important;
                }
            }
            > div {
                max-height: 100vh;
                margin: 0 0 0 auto;
                max-width: 35.625rem;
                border: 1px solid rgba(7,15,44,0.08);
                border-radius: 1px;
                background-color: ${themeColors.colorWhite};
                @media (max-width: 767px) {
                    max-width: 100%;
                    margin-right: 0;
                    margin-left: 0;
                }

                > div:last-child {
                    padding: 0;
                    > form {
                        > div {
                            padding: 1.875rem;
                        }

                        > div:last-child {
                            border-radius: 1px;
                            background: ${themeColors.colorWhite};
                            box-shadow: 0 -2px 6px 0 rgba(0,0,0,0.31);
                            padding-left: 0;
                            padding-right: 0;

                            @media screen and (max-width: 767px) {
                                box-shadow: none;
                            }
                        }
                        @media screen and (max-width: 326px) {
                            > div {
                                padding: 1.875rem 1.875rem 2.2rem;
                            }
                            > div:last-child {
                                padding-top: 7.5rem;
                                padding-bottom: 3.875rem;
                            }                            
                        }
                        @media screen and (min-width: 360px) and (max-width: 369px) {                            
                            > div:last-child {
                                padding-top: 5rem;
                            }                            
                        }
                        @media screen and (min-width: 370px) and (max-width: 379px) {                          
                            > div:last-child {
                                padding-top: 2.8rem;
                            }                            
                        }
                        @media screen and (min-width: 380px) and (max-width: 414px) {                        
                            > div:last-child {
                                padding-top: 3rem;
                            }                            
                        }
                    }
                }
                #modalTitle{
                    border-bottom: none;
                    padding-bottom: 0px;

                    h4 {
                        color: ${themeColors.colorPrimary};
                        font-family: Roboto;
                        font-size: 1.125rem;
                        font-weight: ${themeFontWeights.fontWeightMedium};
                        letter-spacing: 0px;
                        line-height: 1.9375rem;
                        padding-top: 4.0625rem;
                        position: relative;
                        &:after {
                            height: 0.1875rem;
                            width: 2.75rem;
                            background: ${themeColors.colorRed};
                            content: "";
                            display: inline-block;
                            position: absolute;
                            bottom: -0.1875rem;
                            left: 1px;
                        }
                    }
                    button[aria-labelledby="close-modal"] {
                        display: none;
                    }
                }
            }
        `,
    },
    addressInfoDisplayGridItem: { 
        width: 12,
        css: css`
            color: ${themeColors.colorSquidInk};
            font-family: 'Lato';
            p {
                font-size: 1rem;
            }

             span[data-test-selector="addressInfoDisplay_firstName"],
             span[data-test-selector="addressInfoDisplay_lastName"] {
                font-weight: ${themeFontWeights.fontWeightForBold};
                font-size: 1rem;
                color: ${themeColors.colorPrimary};
            }
        `, 
    },
    currentBillingHandlingLabel: {
        css: css`
            //position: relative;
            font-size: 1rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            -webkit-letter-spacing: -.019rem;
            -moz-letter-spacing: -.019rem;
            -ms-letter-spacing: -.019rem;
            letter-spacing: -.019rem;
            line-height: 1.438rem;
        `,
    },
    tooltipIcon: {
        css: css`
            display: inline-block;
            position: absolute;
            right: 0;
            top: 0;
            margin-left: 0.3125rem;
            svg {
                width: 1.5rem;
                height: 1.5rem;
                scale: 0.8;
            }
        `,
    },
    tooltip: {
        css: css`
            background-color: ${themeColors.colorWhite};
            box-shadow: 0 0.4375rem 1.0625rem 0 rgba(0,37,84,0.23);
            position: absolute;
            width: 250px;
            padding: 1.5625rem;
            right: -2.875rem;
            bottom: auto;
            top: -7.125rem;
            display: none;
            z-index: 2;

            &.active {
                display: block;
            }
        `,
    },
    tooltipHeading: {
        css: css`
            position: relative;
            color: ${themeColors.colorPrimary};
            font-family: Roboto;
            font-size: 1.125rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.9375rem;
            margin-bottom: 1.25rem;
            text-align: left;
            &:after {
                height: 0.1875rem;
                width: 0.665rem;
                background-color: ${themeColors.colorRed};
                content: '';
                display: inline-block;
                position: absolute;
                bottom: -0.125rem;
                left: 1px;
            }
        `,
    },
    tooltipContent: {
        css: css`
            color: ${themeColors.colorMeasureText};
            font-family: Lato;
            font-size: .9375rem;
            letter-spacing: 0.17px;
            line-height: 1.5rem;
            text-align: left !important;

            &:after {
                content: '';
                display: block;
                height: 0;
                position: absolute;
                width: 0;
                border: 0.75rem solid;
                border-color: ${themeColors.colorWhite} transparent transparent transparent;
                z-index: 99;
                bottom: -1.4375rem;
                right: 2.8125rem;
            }



            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            &:after {
                                right: 3.0625rem !important;
                            }
                        `,
                        css`
                            &:after {
                                right: 3.0625rem;
                            }
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = currentBillingAddressStyles;

const CurrentBillingAddress: React.FunctionComponent<Props> = (props: Props) => {
    const [showText, setShowText] = React.useState(false);
    const [phoneNumber,setPhoneNumber]=React.useState("");
    
    React.useEffect(() => {
        const webSitePhoneNumber=(document.querySelector('.phone-link'))as HTMLElement; 
        if (webSitePhoneNumber) {           
            setPhoneNumber(webSitePhoneNumber.innerText);
        }
    }, [props]);
    const currentBillingHandlingText = siteMessage("Current_Billing_Addresses_Tooltip",phoneNumber).toString();

    const { currentBillTo } = props;
    const{ currentShipTosDataView}=props;

    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    
    if (!currentBillTo || !currentShipTosDataView.value) {
        return null;
    }
    const billToAsShipTo = currentShipTosDataView.value.find(o => o.id === currentBillTo.id);
    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };
    const editClickHandler = () => {
        setModalIsOpen(true);
    };
    const formCancelHandler = (e: any) => {
        e.preventDefault();
        modalCloseHandler();
    };
    const formSubmitHandler = (_: React.FormEvent<HTMLFormElement>, address: BillToModel) => {
        if (!props.currentBillTo) {
            return;
        }
        props.updateBillTo({
            billTo: {
                ...props.currentBillTo,
                ...address,
            },
            isEdit: true,
        });
        modalCloseHandler();
    };

    const { countries, billToAddressFields } = props;

    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.headingText}>
                    {translate("Billing Information")}
                   
                </Typography>
            </GridItem>
            
            <GridItem {...styles.addressInfoDisplayGridItem}>
                <AddressInfoDisplay
                    firstName={currentBillTo.firstName}
                    lastName={currentBillTo.lastName}
                    companyName={currentBillTo.companyName}
                    attention={currentBillTo.attention}
                    address1={currentBillTo.address1}
                    address2={currentBillTo.address2}
                    address3={currentBillTo.address3}
                    address4={currentBillTo.address4}
                    city={currentBillTo.city}
                    state={currentBillTo.state ? currentBillTo.state.abbreviation : undefined}
                    postalCode={currentBillTo.postalCode}
                    country={currentBillTo.country ? currentBillTo.country.abbreviation : undefined}
                    phone={currentBillTo.phone}
                    fax={currentBillTo.fax}
                    email={currentBillTo.email}
                />
            </GridItem>
            <StyledWrapper {...styles.currentAddressAction}>
                <GridItem {...styles.editLinkGridItem}>
                    {billToAsShipTo?.properties?.isErpNumberNotAvailable === "true" && countries && (
                        <Link
                            {...styles.editLink}
                            onClick={editClickHandler}
                            data-test-selector="billTo_Edit_Address"
                        >
                            <Icon src={EditIcon} />
                            <VisuallyHidden>{translate("Edit")}</VisuallyHidden>
                        </Link>

                    )}
                    {countries && billToAddressFields && (
                        <Modal
                            headline={translate("Edit billing information address")}
                            {...styles.addressFormModal}
                            isOpen={modalIsOpen}
                            handleClose={modalCloseHandler}
                            {...styles.addressFormModalCustom}
                        >
                            <Typography as="div" onClick={modalCloseHandler} {...styles.closeContainer}>
                                <span className="close-label">Close</span>
                                <Icon className="icon-close" src="XCircle" />
                            </Typography>
                            <CustomerAddressForm
                                address={currentBillTo}
                                countries={countries}
                                addressFieldDisplayCollection={billToAddressFields}
                                onCancel={formCancelHandler}
                                onSubmit={formSubmitHandler}
                            />
                        </Modal>
                    )}
                </GridItem>
            </StyledWrapper>
            {billToAsShipTo?.properties?.isErpNumberNotAvailable !== "true" && (
                <GridItem  {...styles.billingEditInfoMessage}>            
                    <Typography {...styles.billingEditInfoText}>                
                        {translate("We're sorry, but you cannot edit this information for this account.")} 

                        <Typography {...styles.currentBillingHandlingLabel}>
                            <Link {...styles.tooltipIcon}
                                onClick={() => setShowText(!showText)}
                                onKeyDown={(e) => e.keyCode === 27 ? setShowText(false) : ''}
                                onBlur={() => setShowText(false)}
                            >
                                <Icon src={InfoNewIcon} />
                            </Link>
                            <Typography as='div' {...styles.tooltip} className={`${showText ? 'active' : ''}`} >
                                <Typography as='div' {...styles.tooltipContent}>{currentBillingHandlingText} </Typography>
                            </Typography>
                        </Typography>                   
                    </Typography>
                </GridItem>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CurrentBillingAddress),
    definition: {
        group: "Addresses",
        allowedContexts: ["AddressesPage"],
    },
};

export default widgetModule;
